export default "__VITE_ASSET__rDoN_FLi__"